<template>
	<div
		class="mb-4 mb-md-0 position-relative font-body"
		:style="{ color: isLoading ? 'lightgray' : 'inherit' }"
	>
		<div class="d-flex flex-row nowrap align-items-center justify-content-end">
			<PlaceholderBox
				v-if="isDisplayPlaceholders"
				:height="'20px'"
				:width="'40px'"
				:additionalClasses="'m-1'"
			/>
			<div
				v-if="crossedPrice >= totalPrice && maxPromo && !isDisplayPlaceholders"
				class="prestation-discount-container d-flex align-items-center justify-content-center bg-primary-green me-2 me-md-1"
			>
				<div
					class="prestation-discount subcaption-strong text-primary-white px-2 py-1 text-nowrap"
					v-bind:class="addDnoneClassIfABtest"
				>
					-{{ parseInt(maxPromo) }}%
				</div>
			</div>
			<div
				v-if="
					(crossedPrice && crossedPrice >= totalPrice) || isDisplayPlaceholders
				"
				class="font-weight-500 font-size-20 me-2 me-md-1 text-grey-500"
				v-bind:class="addDnoneClassIfABtest"
			>
				<PlaceholderBox
					v-if="isDisplayPlaceholders"
					:height="'20px'"
					:width="'60px'"
					:additionalClasses="'m-1'"
				/>
				<template v-else-if="crossedPriceString && crossedPrice >= totalPrice">
					<del class="prestation-crossed-price text-nowrap text-grey-500">{{
						crossedPriceString
					}}</del>
				</template>
			</div>
			<div class="prestation-price heading text-grey-900 me-0">
				<PlaceholderBox
					v-if="isDisplayPlaceholders"
					:height="'20px'"
					:width="'60px'"
					:additionalClasses="'m-1'"
				/>
				<template v-else-if="totalPriceString">
					<span class="text-nowrap">
						{{ totalPriceString }}
					</span>
				</template>
			</div>
		</div>
		<div
			class="font-weight-500 font-size-14 d-flex justify-content-end"
			style="color: #173e67"
		>
			<PlaceholderBox
				v-if="isDisplayPlaceholders"
				:height="'20px'"
				:width="'80px'"
				:additionalClasses="'m-1'"
			/>
			<template v-else-if="perPriceString">
				<span
					class="prestation-price-per-person subcaption text-grey-900 text-end text-nowrap"
				>
					{{ content.planner_resumeOr }}
					{{ perPriceString }}
					{{ `/${content.planner_resumePerPerson}` }}
				</span>
			</template>
		</div>

		<div class="loader-wrapper">
			<span
				v-if="!isDisplayPlaceholders && isLoading"
				class="price-loader price-loader-container"
			></span>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex"
import PlaceholderBox from "@/vue/planning/components/common/placeholderBox.vue"

import displayPrice from "@/displayPrice/displayPrice"
import store from "@/vue/planning/store/store"
import { isABtest } from "@/utils/utils"


export default {
	store,
	name: "Prices",
	props: {
		maxPromo: {
			type: Number,
			default: 0,
		},
		crossedPrice: {
			type: Number,
			default: 0,
		},
		totalPrice: {
			type: Number,
			default: 0,
		},
		perPrice: {
			type: Number,
			default: 0,
		},
		isDisplayPlaceholders: {
			type: Boolean,
			default: false,
		},
		locale: {
			type: String,
			default: "fr_FR",
		},
		isLoading: Boolean,
	},
	components: {
		PlaceholderBox,
	},
	computed: {
		...mapState(["content"]),
		crossedPriceString() {
			return (
				this.crossedPrice &&
				this.displayPrice(parseInt(this.crossedPrice) * 100, this.locale)
			)
		},
		totalPriceString() {
			return (
				this.totalPrice &&
				this.displayPrice(parseInt(this.totalPrice) * 100, this.locale)
			)
		},
		perPriceString() {
			return (
				this.perPrice &&
				this.displayPrice(parseInt(this.perPrice) * 100, this.locale)
			)
		},
		addDnoneClassIfABtest() {
			const dNoneClass = isABtest() ? "d-none !important" : ""
			return dNoneClass
		},
	},

	methods: {
		displayPrice,
	},
}
</script>

<style scoped>
.prestation-discount-container {
	border-radius: 37px;
}
.loader-wrapper {
	top: 0;
	left: 0;
	position: absolute;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.price-loader {
	height: 50px;
	background-size: 50px;
}

@keyframes rotation {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}

/* .info-icon {
	z-index: ;
} */

.info-icon:hover + .package-info-container {
	visibility: visible;
}

@media (max-width: 1500px) and (min-width: 1201px) {
	.prestation-price {
		order: 2;
	}
	
	.font-weight-500.font-size-20 {
		order: 1;
		margin-bottom: 0.5rem !important;
	}
	
	.d-flex.flex-row.nowrap.align-items-center.justify-content-end {
		flex-direction: column !important;
		align-items: flex-end !important;
	}
}
</style>
